import React from 'react';
import '../styles/theme.css';
import '../styles/Apply.css';
import MontreauxSiteHeader from '../components/MontreauxSiteHeader';
import Footer from '../components/Footer';
import ApplyTitle from '../components/ApplyTitle';
import ApplyApplicationPanel from '../components/ApplyApplicationPanel';
/* IMPORTS */

function ApplyPage() {
  return (
    <div className="ap-root">
      <div className="ap-layout-1">
        <div id="applysiteheader" className="ap-slot-applysiteheader">
          <MontreauxSiteHeader activePage={"Apply"} />
        </div>
        <div className="ap-layout-2">
          <div id="applytitle" className="ap-slot-applytitle">
            <ApplyTitle />
          </div>
          <div id="applyapplicationpanel" className="ap-slot-applyapplicationpanel">
            <ApplyApplicationPanel />
          </div>
        </div>
        <div id="applysitefooter" className="ap-slot-applysitefooter">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default ApplyPage;
